import { SxProps } from '@mui/material';

export const listStyles = (centered: boolean, listTag: 'ul' | 'ol'): SxProps => ({
  listStyle: listTag === 'ul' ? 'disc' : 'decimal',
  pl: 4,
  mt: 2,
  mb: 2,
  pt: 0,
  pb: 0,
  '& li': {
    display: 'list-item',
    '& p': {
      marginTop: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  ...(centered && {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& li': {
      display: 'list-item',
      width: 'inherit',
    },
  }),
});

export const richTextStyles: SxProps = {
  mb: 0
}